import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=37b3b0d6"
import script from "./PageSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PageSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageSection.vue?vue&type=style&index=0&id=37b3b0d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports